import api from "../services/api";

/** Upload de materiais via API (backend envia ao S3; não usa credenciais AWS no browser). */

/** Extensões e MIME types comuns do pacote Office para o atributo accept do input */
export const OFFICE_ACCEPT =
  ".doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.rtf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation";

/**
 * Envia arquivos ao backend; o servidor grava no S3 (credenciais só no backend).
 * @param {File[]} files
 * @param {{ headers?: object }} [opts]
 * @returns {Promise<{ url: string, nome: string }[]>}
 */
export async function uploadMaterialFiles(files, opts = {}) {
  if (!files || files.length === 0) {
    throw new Error("Nenhum arquivo selecionado.");
  }
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append("files", files[i]);
  }
  const empresaid = localStorage.getItem("sgiempresaid");
  const isMaster = localStorage.getItem("sgimaster");
  const headers = {
    ...(opts.headers || {}),
    "x-tenantid": empresaid,
    isMaster,
  };
  try {
    const response = await api.post(
      "/treinamentos/produto/material/upload",
      formData,
      { headers }
    );
    const items = response.data && response.data.items;
    if (!Array.isArray(items)) {
      throw new Error("Resposta inválida do servidor.");
    }
    return items;
  } catch (e) {
    const msg =
      (e.response &&
        e.response.data &&
        (e.response.data.error || e.response.data.message)) ||
      e.message ||
      "Erro ao enviar arquivo(s).";
    throw new Error(msg);
  }
}
